export default "__VITE_ASSET__wXHqgGwK__"